// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3oTDB","footer":"ModalError_footer__2VWsQ"};